export const SalahTimes = ({ todaysData, jummahTimes }) => {
  return (
    <div className="salah-block-content mceNonEditable">
      <div className="salah-times">
        <SalahHeader />
        <SalahRow
          label="Begins"
          fajr={todaysData?.['Fajr Start']}
          zuhr={todaysData?.['Zuhr Start']}
          asr={todaysData?.['Asr Start']}
          maghrib={todaysData?.['Magrib']}
          isha={todaysData?.['Isha Start']}
        />
        <SalahRow
          label="Jamā'ah"
          fajr={todaysData?.['Fajr Jamaat']}
          zuhr={todaysData?.['Zuhr Jamaat']}
          asr={todaysData?.['Asr Jamaat']}
          maghrib={todaysData?.['Magrib']}
          isha={todaysData?.['Isha Jamaat']}
        />
        <JummahRow jummahTimes={jummahTimes} />
      </div>
    </div>
  );
};

const SalahHeader = () => (
  <div className="salah-time-row">
    <span className="col1 col-s"></span>
    <span className="col3 col-s">Fajr</span>
    <span className="col4 col-s">Zuhr</span>
    <span className="col5 col-s">'Asr</span>
    <span className="col6 col-s">Maghrib</span>
    <span className="col7 col-s">'Ishā</span>
  </div>
);

const SalahRow = ({ label, fajr, zuhr, asr, maghrib, isha }) => (
  <div className={`salah-time-row ${label === 'Begins' ? 'time-start' : 'time-end'}`}>
    <span className="col1 col-s">{label}</span>
    <span className="col3 col-s fajr">{fajr}</span>
    <span className="col4 col-s zuhr">{zuhr}</span>
    <span className="col5 col-s asr">{asr}</span>
    <span className="col6 col-s maghrib">{maghrib}</span>
    <span className="col7 col-s isha">{isha}</span>
  </div>
);

const JummahRow = ({ jummahTimes }) => (
  <>
    <div className="salah-time-row jummah">
      <span className="col1 col-s" />
      <span className="col3 col-s fajr" />
      <span className="col4 col-s zuhr" />
      <span className="col5 col-s asr" />
      <span className="col6 col-s maghrib" />
      <span className="col7 col-s isha" />
    </div>
    <div className="salah-time-row jummah">
      <span className="col1 col-s"></span>
      <span className="col3 col-s fajr">1st</span>
      <span className="col4 col-s zuhr">2nd</span>
      <span className="col5 col-s asr">Girls' School</span>
      <span className="col6 col-s maghrib" />
    </div>
    <div className="salah-time-row jummah">
      <span className="col1 col-s">Jummah</span>
      <span className="col3 col-s fajr">{jummahTimes?.[0]}</span>
      <span className="col4 col-s zuhr">{jummahTimes?.[1]}</span>
      <span className="col5 col-s asr">{jummahTimes?.[2]}</span>
      <span className="col6 col-s maghrib" />
    </div>
  </>
);
